import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";
import { LOGO_URL } from "@/lib/api";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) { toast.success("Welcome back!"); navigate("/admin"); }
    else { toast.error(res.error || "Invalid credentials"); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
        <div className="text-center">
          <img src={LOGO_URL} alt="JAS" className="h-16 w-16 rounded-full mx-auto ring-1 ring-slate-200" />
          <h1 className="font-display font-black text-3xl mt-4 text-[#0b1838]">Admin sign in</h1>
          <p className="text-sm text-slate-500 mt-2">Manage products and leads</p>
        </div>
        <form onSubmit={submit} className="mt-8 grid gap-4" data-testid="admin-login-form">
          <div className="flex items-center gap-2 border border-slate-300 rounded-lg px-3 bg-white">
            <Mail size={16} className="text-slate-400" />
            <input required type="email" placeholder="Email" data-testid="admin-login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="flex-1 py-3 outline-none text-sm" />
          </div>
          <div className="flex items-center gap-2 border border-slate-300 rounded-lg px-3 bg-white">
            <Lock size={16} className="text-slate-400" />
            <input required type="password" placeholder="Password" data-testid="admin-login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="flex-1 py-3 outline-none text-sm" />
          </div>
          <button type="submit" disabled={submitting} data-testid="admin-login-submit" className="px-6 py-3 bg-[#1a2d5e] text-white font-semibold rounded-lg hover:bg-[#0b1838] disabled:opacity-60">{submitting ? "Signing in…" : "Sign in"}</button>
        </form>
      </div>
    </div>
  );
}
